import {
    DefaultButton,
    DetailsList,
    Dialog, DialogFooter, DialogType,
    FontSizes,
    FontWeights,
    IconButton,
    PrimaryButton,
    SelectionMode,
    Stack
} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import { useContext, useEffect, useState } from "react";
import * as React from "react";
import AddTransactionInvoiceDocument from "../Panel/TransactionInvoice/AddTransactionInvoiceDocument";
import ProjectLink from "../Components/ProjectLink";
import {MoneyField} from "../Utilities/MoneyField";
import { netGrossColumn } from "../Utilities/NetGrossField";

function InvoiceList(props) {
    const [user] = useContext(AuthContext);
    const [addFile, setAddFile] = useState(false);
    const [sendInvoice, setSendInvoice] = useState(false);

    const _sendInvoice = () => {
        fetch(`/api/transaction/invoice/${sendInvoice.id}/send`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setSendInvoice(false); props.refresh(); })
            .catch(err => { console.log(err) })
    };

    const _sendInvoiceButton = (item) => {
        if (item.sent !== null || item.filename === null) {
            return item.sent;
        }
        return (<IconButton iconProps={ {iconName: 'NewMail' }} title='Wyślij Fakturę' onClick={() => setSendInvoice(item)}/>);
    };

    const _fileLink = (item) => {
        if (item.filename === null) {
            return item.invoice_number;
        }
        return (<a href={`/api/public/uploaded/${item.filename}`} target={'_blank'} rel={'noreferrer'}><PrimaryButton text={item.invoice_number} /></a>);
    };
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        let actions = {
            key: 'project',
            name: 'Projekt',
            ariaLabel: 'Projekt',
            fieldName: 'project',
            minWidth: 160,
            isResizable: true,
            onRender: (item) => ProjectLink({id: item.project_id, name: item.project})
        };
        if (props.project) {
            actions = {
                key: 'delete',
                name: 'Akcje',
                ariaLabel: 'Akcje',
                fieldName: 'delete',
                minWidth: 80,
                isResizable: true,
                onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'upload' }} title='Dodaj Plik' onClick={() => setAddFile(item)}/>
                <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => _delete(item)}/>
            </span>)
            };
        }
        setColumns([
            {
                key: 'invoice_number',
                name: 'Faktura',
                ariaLabel: 'Faktura',
                fieldName: 'invoice_number',
                minWidth: 250,
                isRowHeader: true,
                isResizable: false,
                onRender: _fileLink
            },
            {
                key: 'deadline',
                name: 'Termin',
                ariaLabel: 'Termin Transzy',
                fieldName: 'deadline',
                minWidth: 120,
                isResizable: true
            },
            {
                minWidth: 120,
                ...netGrossColumn()
            },
            {
                key: 'sent',
                name: 'Wysłano',
                ariaLabel: 'Wysłano',
                fieldName: 'sent',
                minWidth: 120,
                isResizable: true,
                onRender: _sendInvoiceButton
            },
            {
                key: 'opened',
                name: 'Otwarto',
                ariaLabel: 'Otwarto',
                fieldName: 'opened',
                minWidth: 120,
                isResizable: true,
            },
            {
                key: 'paid',
                name: 'Opłacono',
                ariaLabel: 'Opłacono',
                fieldName: 'paid',
                minWidth: 120,
                isResizable: true,
            },
            actions
        ]);
    }, [props.netGross]);


    const _delete = (addon) => {
        fetch(`/api/transaction/invoice/${addon.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.refresh() })
            .catch(err => { console.log(err) })
    }
    const dialogContentProps = {
        type: DialogType.normal,
        title: 'Wysyłka faktury',
        subText: 'Czy na pewno chcesz wysłać tą fakturę do klienta?',
    };
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
            <AddTransactionInvoiceDocument add={addFile} dismissPanel={() => setAddFile(false)} onSuccess={props.refresh}/>
            <Dialog
                hidden={!sendInvoice}
                onDismiss={() => setSendInvoice(false)}
                dialogContentProps={dialogContentProps}
                isBlocking={true}
            >
                <DialogFooter>
                    <PrimaryButton onClick={_sendInvoice} text="Wyślij" />
                    <DefaultButton onClick={() => setSendInvoice(false)} text="Anuluj" />
                </DialogFooter>
            </Dialog>
        </Stack.Item>);
    }
    return null;
}

InvoiceList.defaultProps = {
    title: 'Faktury',
    project: true
}

export default InvoiceList;